import { render, staticRenderFns } from "./KbDocuments.vue?vue&type=template&id=f66f9e02&scoped=true"
import script from "./KbDocuments.vue?vue&type=script&lang=js"
export * from "./KbDocuments.vue?vue&type=script&lang=js"
import style0 from "./KbDocuments.vue?vue&type=style&index=0&id=f66f9e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f9e02",
  null
  
)

export default component.exports